import { CommonModule } from '@angular/common';
import { Component, computed } from '@angular/core';
import { XMLElementBaseComponent } from '../base';
import { Pos } from '../volkswagen.types';
import { HighlightLinkComponent } from './svg/highlight-link.component';

@Component({
  selector: 'app-img-link',
  imports: [CommonModule, HighlightLinkComponent],
  standalone: true,
  template: `
    @if (displayText()) {
      <app-highlight-link [componentIdWithinImage]="displayText()" [elClass]="'font-semibold'" [activeClass]="'underline'">
        {{ displayText() }}
      </app-highlight-link>
    }
  `,
})
export class ImgLinkComponent extends XMLElementBaseComponent<Pos> {
  displayText = computed(() => (this.data as never as any)?.text || '');
}
